import { container } from '@/container';

export const PrintOrderGiftAidDeclarationMixin = {
    computed: {
        showGiftAidDeclarationButton() {
            return this.order.giftAid
                && !!container.userService.company.settings.printGiftAidDeclarationOnPropointBocaReceipts
                && !!container.userService.company.settings.giftAidDeclarationForReceipts;
        },
    },

    methods: {
        printGiftAidDeclaration() {
            this.isPrinting = true;

            container.receiptPrinter
                .printGiftAidDeclaration(
                    this.order,
                    // Initially we will always use a Boca printer. In the future this will probably be controlled
                    // by a new setting rather than relying on devices.printTickets for more granular control.
                    true,
                )
                .then(() => {
                    this.isPrinting = false;
                });
        },
    },
};
